const figmaTheme = {
  colorSchemes: {
    light: {
      palette: {
        primary: {
          main: "#A90E7C",
          dark: "#5C0041",
          light: "#FF38C8",
          contrastText: "#FFFFFF",
          _states: {
            hover: "rgba(156, 39, 176, 0.04)",
            selected: "rgba(156, 39, 176, 0.08)",
            focus: "rgba(156, 39, 176, 0.12)",
            focusVisible: "rgba(156, 39, 176, 0.3)",
            outlinedBorder: "rgba(156, 39, 176, 0.5)",
          },
        },
        secondary: {
          main: "#1976D2",
          dark: "#1565C0",
          light: "#42A5F5",
          contrastText: "#FFFFFF",
          _states: {
            hover: "rgba(25, 118, 210, 0.04)",
            selected: "rgba(25, 118, 210, 0.08)",
            focus: "rgba(25, 118, 210, 0.12)",
            focusVisible: "rgba(25, 118, 210, 0.3)",
            outlinedBorder: "rgba(25, 118, 210, 0.5)",
          },
        },
        error: {
          contrastText: "#FFFFFF",
          main: "#D32F2F",
          _states: {
            focusVisible: "rgba(211, 47, 47, 0.3)",
            outlinedBorder: "rgba(211, 47, 47, 0.5)",
          },
        },
        warning: {
          contrastText: "#FFFFFF",
          main: "#EF6C00",
          dark: "#E65100",
          _states: {
            focusVisible: "rgba(239, 108, 0, 0.3)",
            outlinedBorder: "rgba(239, 108, 0, 0.5)",
          },
        },
        info: {
          contrastText: "#FFFFFF",
          main: "#0288D1",
          _states: {
            outlinedBorder: "rgba(2, 136, 209, 0.5)",
          },
        },
        success: {
          contrastText: "#FFFFFF",
          main: "#2E7D32",
          _states: {
            focusVisible: "rgba(46, 125, 50, 0.3)",
            outlinedBorder: "rgba(46, 125, 50, 0.5)",
          },
        },
        background: {
          contentBackground: "#F5F5F5",
        },
        action: {
          disabled: "rgba(0, 0, 0, 0.38)",
          disabledBackground: "rgba(0, 0, 0, 0.12)",
        },
        text: {
          primary: "rgba(0, 0, 0, 0.87)",
          secondary: "rgba(0, 0, 0, 0.60)",
          _states: {
            focusVisible: "rgba(0, 0, 0, 0.3)",
          },
        },
        common: {
          white_states: {
            main: "#FFFFFF",
            focusVisible: "rgba(255, 255, 255, 0.3)",
          },
        },
        _components: {
          switch: {
            knobFillEnabled: "#FAFAFA",
            slideFill: "#000000",
          },
        },
      },
      gradients: {
        primary:
          "radial-gradient(50% 50% at 50% 50%, var(--primary-light, rgba(255, 56, 200, 0.20)) 0%, var(--secondary-light, rgba(66, 165, 245, 0.20)) 100%), linear-gradient(90deg, var(--primary-light, rgba(255, 56, 200, 0.96)) 0%, var(--primary-main, rgba(169, 14, 124, 0.96)) 100%)",
        primaryDisabled:
          "radial-gradient(50% 50% at 50% 50%, rgba(189, 189, 189, 0.20) 0%, rgba(158, 158, 158, 0.20) 100%), linear-gradient(90deg, rgba(189, 189, 189, 0.96) 0%, rgba(158, 158, 158, 0.96) 100%)",
        secondary: "linear-gradient(45deg, #9c27b0 30%, #e040fb 90%)",
      },
    },
    dark: {
      palette: {
        primary: {
          main: "#FF80DF",
          dark: "#D4179E",
          light: "#FFDFF6",
          contrastText: "rgba(0, 0, 0, 0.87)",
          _states: {
            hover: "rgba(206, 147, 216, 0.08)",
            selected: "rgba(206, 147, 216, 0.16)",
            focus: "rgba(206, 147, 216, 0.12)",
            focusVisible: "rgba(206, 147, 216, 0.3)",
            outlinedBorder: "rgba(206, 147, 216, 0.5)",
          },
        },
        secondary: {
          main: "#90CAF9",
          dark: "#42A5F5",
          light: "#E3F2FD",
          contrastText: "rgba(0, 0, 0, 0.87)",
          _states: {
            hover: "rgba(144, 202, 249, 0.08)",
            selected: "rgba(144, 202, 249, 0.16)",
            focus: "rgba(144, 202, 249, 0.12)",
            focusVisible: "rgba(144, 202, 249, 0.3)",
            outlinedBorder: "rgba(144, 202, 249, 0.5)",
          },
        },
        error: {
          contrastText: "#FFFFFF",
          main: "#F44336",
          _states: {
            focusVisible: "rgba(244, 67, 54, 0.3)",
            outlinedBorder: "rgba(244, 67, 54, 0.5)",
          },
        },
        warning: {
          contrastText: "rgba(0, 0, 0, 0.87)",
          main: "#FFA726",
          dark: "#F57C00",
          _states: {
            focusVisible: "rgba(255, 167, 38, 0.3)",
            outlinedBorder: "rgba(255, 167, 38, 0.5)",
          },
        },
        info: {
          contrastText: "rgba(0, 0, 0, 0.87)",
          main: "#29B6F6",
          _states: {
            outlinedBorder: "rgba(41, 182, 246, 0.5)",
          },
        },
        success: {
          contrastText: "rgba(0, 0, 0, 0.87)",
          main: "#66BB6A",
          _states: {
            focusVisible: "rgba(102, 187, 106, 0.3)",
            outlinedBorder: "rgba(102, 187, 106, 0.5)",
          },
        },
        background: {
          contentBackground: "#616161",
        },
        action: {
          disabled: "rgba(255, 255, 255, 0.38)",
          disabledBackground: "rgba(255, 255, 255, 0.12)",
        },
        text: {
          primary: "rgba(255, 255, 255, 0.87)",
          secondary: "rgba(255, 255, 255, 0.60)",
          _states: {
            focusVisible: "rgba(255, 255, 255, 0.3)",
          },
        },
        common: {
          white_states: {
            main: "#FFFFFF",
            focusVisible: "rgba(255, 255, 255, 0.3)",
          },
        },
        _components: {
          switch: {
            knobFillEnabled: "#E0E0E0",
            slideFill: "rgba(255, 255, 255, 0.38)",
          },
        },
      },
      gradients: {
        primary:
          "radial-gradient(50% 50% at 50% 50%, var(--primary-light, rgba(255, 223, 246, 0.20)) 0%, var(--secondary-light, rgba(227, 242, 253, 0.20)) 100%), linear-gradient(90deg, var(--primary-light, rgba(255, 223, 246, 0.96)) 0%, var(--primary-main, rgba(255, 128, 223, 0.96)) 100%)",
        primaryDisabled:
          "radial-gradient(50% 50% at 50% 50%, rgba(117, 117, 117, 0.20) 0%, rgba(97, 97, 97, 0.20) 100%), linear-gradient(90deg, rgba(117, 117, 117, 0.96) 0%, rgba(97, 97, 97, 0.96) 100%)",
        secondary: "linear-gradient(45deg, #9c27b0 30%, #e040fb 90%)",
      },
    },
  },
  shadows: [
    "none",
    "0px 1px 2px 1px rgba(0, 0, 0, 0.06), 0px 0px 1px -2px rgba(0, 0, 0, 0.08);",
    "0px 4px 6px 1px rgba(0, 0, 0, 0.06), 0px 0px 2px 0px rgba(0, 0, 0, 0.12);",
    "0px 6px 12px 4px rgba(0, 0, 0, 0.06), 0px 4px 8px 1px rgba(0, 0, 0, 0.04);",
    "0px 8px 24px 3px rgba(0, 0, 0, 0.08), 0px 6px 10px 1px rgba(0, 0, 0, 0.04);",
    "0px 3px 5px -1px rgba(0, 0, 0, 0.20), 0px 5px 8px 0px rgba(0, 0, 0, 0.14), 0px 1px 14px 0px rgba(0, 0, 0, 0.12);",
    "0px 3px 5px -1px rgba(0, 0, 0, 0.20), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);",
    "0px 4px 5px -2px rgba(0, 0, 0, 0.20), 0px 7px 10px 1px rgba(0, 0, 0, 0.14), 0px 2px 16px 1px rgba(0, 0, 0, 0.12);",
    "0px 5px 5px -3px rgba(0, 0, 0, 0.20), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);",
    "0px 5px 6px -3px rgba(0, 0, 0, 0.20), 0px 9px 12px 1px rgba(0, 0, 0, 0.14), 0px 3px 16px 2px rgba(0, 0, 0, 0.12);",
    "0px 6px 6px -3px rgba(0, 0, 0, 0.20), 0px 10px 14px 1px rgba(0, 0, 0, 0.14), 0px 4px 18px 3px rgba(0, 0, 0, 0.12);",
    "0px 6px 7px -4px rgba(0, 0, 0, 0.20), 0px 11px 15px 1px rgba(0, 0, 0, 0.14), 0px 4px 20px 3px rgba(0, 0, 0, 0.12);",
    "0px 7px 8px -4px rgba(0, 0, 0, 0.20), 0px 12px 17px 2px rgba(0, 0, 0, 0.14), 0px 5px 22px 4px rgba(0, 0, 0, 0.12);",
    "0px 7px 8px -4px rgba(0, 0, 0, 0.20), 0px 13px 19px 2px rgba(0, 0, 0, 0.14), 0px 5px 24px 4px rgba(0, 0, 0, 0.12);",
    "0px 7px 9px -4px rgba(0, 0, 0, 0.20), 0px 14px 21px 2px rgba(0, 0, 0, 0.14), 0px 5px 26px 4px rgba(0, 0, 0, 0.12);",
    "0px 8px 9px -5px rgba(0, 0, 0, 0.20), 0px 15px 22px 2px rgba(0, 0, 0, 0.14), 0px 6px 28px 5px rgba(0, 0, 0, 0.12);",
    "0px 8px 10px -5px rgba(0, 0, 0, 0.20), 0px 16px 24px 2px rgba(0, 0, 0, 0.14), 0px 6px 30px 5px rgba(0, 0, 0, 0.12);",
    "0px 8px 11px -5px rgba(0, 0, 0, 0.20), 0px 17px 26px 2px rgba(0, 0, 0, 0.14), 0px 6px 32px 5px rgba(0, 0, 0, 0.12);",
    "0px 9px 11px -5px rgba(0, 0, 0, 0.20), 0px 18px 28px 2px rgba(0, 0, 0, 0.14), 0px 7px 34px 6px rgba(0, 0, 0, 0.12);",
    "0px 9px 12px -6px rgba(0, 0, 0, 0.20), 0px 19px 29px 2px rgba(0, 0, 0, 0.14), 0px 7px 36px 6px rgba(0, 0, 0, 0.12);",
    "0px 10px 13px -6px rgba(0, 0, 0, 0.20), 0px 20px 31px 3px rgba(0, 0, 0, 0.14), 0px 8px 38px 7px rgba(0, 0, 0, 0.12);",
    "0px 10px 13px -6px rgba(0, 0, 0, 0.20), 0px 21px 33px 3px rgba(0, 0, 0, 0.14), 0px 8px 40px 7px rgba(0, 0, 0, 0.12);",
    "0px 10px 14px -6px rgba(0, 0, 0, 0.20), 0px 22px 35px 3px rgba(0, 0, 0, 0.14), 0px 8px 42px 7px rgba(0, 0, 0, 0.12);",
    "0px 11px 14px -7px rgba(0, 0, 0, 0.20), 0px 23px 36px 3px rgba(0, 0, 0, 0.14), 0px 9px 44px 8px rgba(0, 0, 0, 0.12);",
    "0px 11px 15px -7px rgba(0, 0, 0, 0.20), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12);",
  ],
  typography: {
    h1: {
      fontSize: "2.5rem",
      fontWeight: 600,
      lineHeight: 1.2,
    },
    h2: {
      fontSize: "2rem",
      fontWeight: 600,
      lineHeight: 1.3,
    },
    h3: {
      fontSize: "1.75rem",
      fontWeight: 600,
      lineHeight: 1.4,
    },
    h4: {
      fontSize: "1.5rem",
      fontWeight: 500,
      lineHeight: 1.4,
    },
    h5: {
      fontSize: "1.25rem",
      fontWeight: 500,
      lineHeight: 1.5,
    },
    h6: {
      fontSize: "1rem",
      fontWeight: 500,
      lineHeight: 1.5,
    },
    body1: {
      fontSize: "1rem",
      lineHeight: 1.5,
    },
    body2: {
      fontSize: "0.875rem",
      lineHeight: 1.43,
    },
    button: {
      textTransform: "none",
      fontWeight: 500,
    },
  },
  components: {
    MuiSwitch: {
      styleOverrides: {
        root: {
          "&.MuiSwitch-sizeMedium:has(.MuiSwitch-colorDefault)": {
            "& .MuiSwitch-switchBase": {
              padding: "9px",
              borderRadius: "100px",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(:has(.Mui-checked)):not(:has(.Mui-disabled)):has(.Mui-focusVisible)": {
              "& .MuiSwitch-switchBase": {
                transform: "translateX(0px) translateY(0px)",
              },
            },
            "&:not(:has(.Mui-checked)):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible))": {
              width: "58px",
              height: "38px",
              transform: "translateX(0px) translateY(0px)",
              padding: "12px",
              background: "none",
              opacity: "1",
              borderRadius: "0",
              boxShadow: "none",
              "& .MuiSwitch-switchBase": {
                transform: "translateX(0px) translateY(0px)",
                "& .MuiSwitch-thumb": {
                  width: "20px",
                  height: "20px",
                  background: "var(--mui-palette-_components-switch-knobFillEnabled)",
                  boxShadow: "var(--mui-shadows-1)",
                  padding: "0",
                  opacity: "1",
                  borderRadius: "50%",
                },
                "& + .MuiSwitch-track": {
                  width: "34px",
                  height: "14px",
                  borderRadius: "100px",
                  background: "var(--mui-palette-_components-switch-slideFill)",
                  padding: "0",
                  opacity: "0.38",
                  boxShadow: "none",
                  transform: "translateX(0px) translateY(0px)",
                },
              },
            },
            "&:has(.Mui-checked):not(:has(.Mui-disabled)):has(.Mui-focusVisible)": {
              "& .MuiSwitch-switchBase": {
                transform: "translateX(20px) translateY(0px)",
              },
            },
            "&:has(.Mui-checked):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible))": {
              width: "58px",
              height: "38px",
              transform: "translateX(0px) translateY(0px)",
              padding: "12px",
              background: "none",
              opacity: "1",
              borderRadius: "0",
              boxShadow: "none",
              "& .MuiSwitch-switchBase": {
                transform: "translateX(20px) translateY(0px)",
                "& .MuiSwitch-thumb": {
                  width: "20px",
                  height: "20px",
                  background: "var(--mui-palette-common-white_states-main)",
                  boxShadow: "var(--mui-shadows-1)",
                  padding: "0",
                  opacity: "1",
                  borderRadius: "50%",
                },
                "& + .MuiSwitch-track": {
                  width: "34px",
                  height: "14px",
                  borderRadius: "100px",
                  background: "var(--mui-palette-_components-switch-slideFill)",
                  padding: "0",
                  opacity: "0.5",
                  boxShadow: "none",
                  transform: "translateX(0px) translateY(0px)",
                },
              },
            },
          },
          "&.MuiSwitch-sizeMedium:has(.MuiSwitch-colorPrimary)": {
            "& .MuiSwitch-switchBase": {
              padding: "9px",
              borderRadius: "100px",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(:has(.Mui-checked)):not(:has(.Mui-disabled)):has(.Mui-focusVisible)": {
              "& .MuiSwitch-switchBase": {
                transform: "translateX(0px) translateY(0px)",
              },
            },
            "&:not(:has(.Mui-checked)):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible))": {
              width: "58px",
              height: "38px",
              transform: "translateX(0px) translateY(0px)",
              padding: "12px",
              background: "none",
              opacity: "1",
              borderRadius: "0",
              boxShadow: "none",
              "& .MuiSwitch-switchBase": {
                transform: "translateX(0px) translateY(0px)",
                "& .MuiSwitch-thumb": {
                  width: "20px",
                  height: "20px",
                  background: "var(--mui-palette-_components-switch-knobFillEnabled)",
                  boxShadow: "var(--mui-shadows-1)",
                  padding: "0",
                  opacity: "1",
                  borderRadius: "50%",
                },
                "& + .MuiSwitch-track": {
                  width: "34px",
                  height: "14px",
                  borderRadius: "100px",
                  background: "var(--mui-palette-_components-switch-slideFill)",
                  padding: "0",
                  opacity: "0.38",
                  boxShadow: "none",
                  transform: "translateX(0px) translateY(0px)",
                },
              },
            },
            "&:has(.Mui-checked):not(:has(.Mui-disabled)):has(.Mui-focusVisible)": {
              "& .MuiSwitch-switchBase": {
                transform: "translateX(20px) translateY(0px)",
              },
            },
            "&:has(.Mui-checked):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible))": {
              width: "58px",
              height: "38px",
              transform: "translateX(0px) translateY(0px)",
              padding: "12px",
              background: "none",
              opacity: "1",
              borderRadius: "0",
              boxShadow: "none",
              "& .MuiSwitch-switchBase": {
                transform: "translateX(20px) translateY(0px)",
                "& .MuiSwitch-thumb": {
                  width: "20px",
                  height: "20px",
                  background: "var(--mui-palette-primary-main)",
                  boxShadow: "var(--mui-shadows-1)",
                  padding: "0",
                  opacity: "1",
                  borderRadius: "50%",
                },
                "& + .MuiSwitch-track": {
                  width: "34px",
                  height: "14px",
                  borderRadius: "100px",
                  background: "var(--mui-palette-primary-main)",
                  padding: "0",
                  opacity: "0.5",
                  boxShadow: "none",
                  transform: "translateX(0px) translateY(0px)",
                },
              },
            },
          },
          "&.MuiSwitch-sizeMedium:has(.MuiSwitch-colorError)": {
            "& .MuiSwitch-switchBase": {
              padding: "9px",
              borderRadius: "100px",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(:has(.Mui-checked)):not(:has(.Mui-disabled)):has(.Mui-focusVisible)": {
              "& .MuiSwitch-switchBase": {
                transform: "translateX(0px) translateY(0px)",
              },
            },
            "&:not(:has(.Mui-checked)):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible))": {
              width: "58px",
              height: "38px",
              transform: "translateX(0px) translateY(0px)",
              padding: "12px",
              background: "none",
              opacity: "1",
              borderRadius: "0",
              boxShadow: "none",
              "& .MuiSwitch-switchBase": {
                transform: "translateX(0px) translateY(0px)",
                "& .MuiSwitch-thumb": {
                  width: "20px",
                  height: "20px",
                  background: "var(--mui-palette-_components-switch-knobFillEnabled)",
                  boxShadow: "var(--mui-shadows-1)",
                  padding: "0",
                  opacity: "1",
                  borderRadius: "50%",
                },
                "& + .MuiSwitch-track": {
                  width: "34px",
                  height: "14px",
                  borderRadius: "100px",
                  background: "var(--mui-palette-_components-switch-slideFill)",
                  padding: "0",
                  opacity: "0.38",
                  boxShadow: "none",
                  transform: "translateX(0px) translateY(0px)",
                },
              },
            },
            "&:has(.Mui-checked):not(:has(.Mui-disabled)):has(.Mui-focusVisible)": {
              "& .MuiSwitch-switchBase": {
                transform: "translateX(20px) translateY(0px)",
              },
            },
            "&:has(.Mui-checked):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible))": {
              width: "58px",
              height: "38px",
              transform: "translateX(0px) translateY(0px)",
              padding: "12px",
              background: "none",
              opacity: "1",
              borderRadius: "0",
              boxShadow: "none",
              "& .MuiSwitch-switchBase": {
                transform: "translateX(20px) translateY(0px)",
                "& .MuiSwitch-thumb": {
                  width: "20px",
                  height: "20px",
                  background: "var(--mui-palette-error-main)",
                  boxShadow: "var(--mui-shadows-1)",
                  padding: "0",
                  opacity: "1",
                  borderRadius: "50%",
                },
                "& + .MuiSwitch-track": {
                  width: "34px",
                  height: "14px",
                  borderRadius: "100px",
                  background: "var(--mui-palette-error-main)",
                  padding: "0",
                  opacity: "0.5",
                  boxShadow: "none",
                  transform: "translateX(0px) translateY(0px)",
                },
              },
            },
          },
          "&.MuiSwitch-sizeMedium:has(.MuiSwitch-colorWarning)": {
            "& .MuiSwitch-switchBase": {
              padding: "9px",
              borderRadius: "100px",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(:has(.Mui-checked)):not(:has(.Mui-disabled)):has(.Mui-focusVisible)": {
              "& .MuiSwitch-switchBase": {
                transform: "translateX(0px) translateY(0px)",
              },
            },
            "&:not(:has(.Mui-checked)):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible))": {
              width: "58px",
              height: "38px",
              transform: "translateX(0px) translateY(0px)",
              padding: "12px",
              background: "none",
              opacity: "1",
              borderRadius: "0",
              boxShadow: "none",
              "& .MuiSwitch-switchBase": {
                transform: "translateX(0px) translateY(0px)",
                "& .MuiSwitch-thumb": {
                  width: "20px",
                  height: "20px",
                  background: "var(--mui-palette-_components-switch-knobFillEnabled)",
                  boxShadow: "var(--mui-shadows-1)",
                  padding: "0",
                  opacity: "1",
                  borderRadius: "50%",
                },
                "& + .MuiSwitch-track": {
                  width: "34px",
                  height: "14px",
                  borderRadius: "100px",
                  background: "var(--mui-palette-_components-switch-slideFill)",
                  padding: "0",
                  opacity: "0.38",
                  boxShadow: "none",
                  transform: "translateX(0px) translateY(0px)",
                },
              },
            },
            "&:has(.Mui-checked):not(:has(.Mui-disabled)):has(.Mui-focusVisible)": {
              "& .MuiSwitch-switchBase": {
                transform: "translateX(20px) translateY(0px)",
              },
            },
            "&:has(.Mui-checked):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible))": {
              width: "58px",
              height: "38px",
              transform: "translateX(0px) translateY(0px)",
              padding: "12px",
              background: "none",
              opacity: "1",
              borderRadius: "0",
              boxShadow: "none",
              "& .MuiSwitch-switchBase": {
                transform: "translateX(20px) translateY(0px)",
                "& .MuiSwitch-thumb": {
                  width: "20px",
                  height: "20px",
                  background: "var(--mui-palette-warning-main)",
                  boxShadow: "var(--mui-shadows-1)",
                  padding: "0",
                  opacity: "1",
                  borderRadius: "50%",
                },
                "& + .MuiSwitch-track": {
                  width: "34px",
                  height: "14px",
                  borderRadius: "100px",
                  background: "var(--mui-palette-warning-main)",
                  padding: "0",
                  opacity: "0.5",
                  boxShadow: "none",
                  transform: "translateX(0px) translateY(0px)",
                },
              },
            },
          },
          "&.MuiSwitch-sizeMedium:has(.MuiSwitch-colorInfo)": {
            "& .MuiSwitch-switchBase": {
              padding: "9px",
              borderRadius: "100px",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(:has(.Mui-checked)):not(:has(.Mui-disabled)):has(.Mui-focusVisible)": {
              "& .MuiSwitch-switchBase": {
                transform: "translateX(0px) translateY(0px)",
              },
            },
            "&:not(:has(.Mui-checked)):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible))": {
              width: "58px",
              height: "38px",
              transform: "translateX(0px) translateY(0px)",
              padding: "12px",
              background: "none",
              opacity: "1",
              borderRadius: "0",
              boxShadow: "none",
              "& .MuiSwitch-switchBase": {
                transform: "translateX(0px) translateY(0px)",
                "& .MuiSwitch-thumb": {
                  width: "20px",
                  height: "20px",
                  background: "var(--mui-palette-_components-switch-knobFillEnabled)",
                  boxShadow: "var(--mui-shadows-1)",
                  padding: "0",
                  opacity: "1",
                  borderRadius: "50%",
                },
                "& + .MuiSwitch-track": {
                  width: "34px",
                  height: "14px",
                  borderRadius: "100px",
                  background: "var(--mui-palette-_components-switch-slideFill)",
                  padding: "0",
                  opacity: "0.38",
                  boxShadow: "none",
                  transform: "translateX(0px) translateY(0px)",
                },
              },
            },
            "&:has(.Mui-checked):not(:has(.Mui-disabled)):has(.Mui-focusVisible)": {
              "& .MuiSwitch-switchBase": {
                transform: "translateX(20px) translateY(0px)",
              },
            },
            "&:has(.Mui-checked):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible))": {
              width: "58px",
              height: "38px",
              transform: "translateX(0px) translateY(0px)",
              padding: "12px",
              background: "none",
              opacity: "1",
              borderRadius: "0",
              boxShadow: "none",
              "& .MuiSwitch-switchBase": {
                transform: "translateX(20px) translateY(0px)",
                "& .MuiSwitch-thumb": {
                  width: "20px",
                  height: "20px",
                  background: "var(--mui-palette-info-main)",
                  boxShadow: "var(--mui-shadows-1)",
                  padding: "0",
                  opacity: "1",
                  borderRadius: "50%",
                },
                "& + .MuiSwitch-track": {
                  width: "34px",
                  height: "14px",
                  borderRadius: "100px",
                  background: "var(--mui-palette-info-main)",
                  padding: "0",
                  opacity: "0.5",
                  boxShadow: "none",
                  transform: "translateX(0px) translateY(0px)",
                },
              },
            },
          },
          "&.MuiSwitch-sizeMedium:has(.MuiSwitch-colorSuccess)": {
            "& .MuiSwitch-switchBase": {
              padding: "9px",
              borderRadius: "100px",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(:has(.Mui-checked)):not(:has(.Mui-disabled)):has(.Mui-focusVisible)": {
              "& .MuiSwitch-switchBase": {
                transform: "translateX(0px) translateY(0px)",
              },
            },
            "&:not(:has(.Mui-checked)):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible))": {
              width: "58px",
              height: "38px",
              transform: "translateX(0px) translateY(0px)",
              padding: "12px",
              background: "none",
              opacity: "1",
              borderRadius: "0",
              boxShadow: "none",
              "& .MuiSwitch-switchBase": {
                transform: "translateX(0px) translateY(0px)",
                "& .MuiSwitch-thumb": {
                  width: "20px",
                  height: "20px",
                  background: "var(--mui-palette-_components-switch-knobFillEnabled)",
                  boxShadow: "var(--mui-shadows-1)",
                  padding: "0",
                  opacity: "1",
                  borderRadius: "50%",
                },
                "& + .MuiSwitch-track": {
                  width: "34px",
                  height: "14px",
                  borderRadius: "100px",
                  background: "var(--mui-palette-_components-switch-slideFill)",
                  padding: "0",
                  opacity: "0.38",
                  boxShadow: "none",
                  transform: "translateX(0px) translateY(0px)",
                },
              },
            },
            "&:has(.Mui-checked):not(:has(.Mui-disabled)):has(.Mui-focusVisible)": {
              "& .MuiSwitch-switchBase": {
                transform: "translateX(20px) translateY(0px)",
              },
            },
            "&:has(.Mui-checked):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible))": {
              width: "58px",
              height: "38px",
              transform: "translateX(0px) translateY(0px)",
              padding: "12px",
              background: "none",
              opacity: "1",
              borderRadius: "0",
              boxShadow: "none",
              "& .MuiSwitch-switchBase": {
                transform: "translateX(20px) translateY(0px)",
                "& .MuiSwitch-thumb": {
                  width: "20px",
                  height: "20px",
                  background: "var(--mui-palette-success-main)",
                  boxShadow: "var(--mui-shadows-1)",
                  padding: "0",
                  opacity: "1",
                  borderRadius: "50%",
                },
                "& + .MuiSwitch-track": {
                  width: "34px",
                  height: "14px",
                  borderRadius: "100px",
                  background: "var(--mui-palette-success-main)",
                  padding: "0",
                  opacity: "0.5",
                  boxShadow: "none",
                  transform: "translateX(0px) translateY(0px)",
                },
              },
            },
          },
          "&.MuiSwitch-sizeMedium:has(.MuiSwitch-colorSecondary)": {
            "& .MuiSwitch-switchBase": {
              padding: "9px",
              borderRadius: "100px",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:has(.Mui-checked):not(:has(.Mui-disabled)):has(.Mui-focusVisible)": {
              "& .MuiSwitch-switchBase": {
                transform: "translateX(20px) translateY(0px)",
              },
            },
            "&:has(.Mui-checked):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible))": {
              width: "58px",
              height: "38px",
              transform: "translateX(0px) translateY(0px)",
              padding: "12px",
              background: "none",
              opacity: "1",
              borderRadius: "0",
              boxShadow: "none",
              "& .MuiSwitch-switchBase": {
                transform: "translateX(20px) translateY(0px)",
                "& .MuiSwitch-thumb": {
                  width: "20px",
                  height: "20px",
                  background: "var(--mui-palette-secondary-main)",
                  boxShadow: "var(--mui-shadows-1)",
                  padding: "0",
                  opacity: "1",
                  borderRadius: "50%",
                },
                "& + .MuiSwitch-track": {
                  width: "34px",
                  height: "14px",
                  borderRadius: "100px",
                  background: "var(--mui-palette-secondary-main)",
                  padding: "0",
                  opacity: "0.5",
                  boxShadow: "none",
                  transform: "translateX(0px) translateY(0px)",
                },
              },
            },
            "&:not(:has(.Mui-checked)):not(:has(.Mui-disabled)):has(.Mui-focusVisible)": {
              "& .MuiSwitch-switchBase": {
                transform: "translateX(0px) translateY(0px)",
              },
            },
            "&:not(:has(.Mui-checked)):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible))": {
              width: "58px",
              height: "38px",
              transform: "translateX(0px) translateY(0px)",
              padding: "12px",
              background: "none",
              opacity: "1",
              borderRadius: "0",
              boxShadow: "none",
              "& .MuiSwitch-switchBase": {
                transform: "translateX(0px) translateY(0px)",
                "& .MuiSwitch-thumb": {
                  width: "20px",
                  height: "20px",
                  background: "var(--mui-palette-_components-switch-knobFillEnabled)",
                  boxShadow: "var(--mui-shadows-1)",
                  padding: "0",
                  opacity: "1",
                  borderRadius: "50%",
                },
                "& + .MuiSwitch-track": {
                  width: "34px",
                  height: "14px",
                  borderRadius: "100px",
                  background: "var(--mui-palette-_components-switch-slideFill)",
                  padding: "0",
                  opacity: "0.38",
                  boxShadow: "none",
                  transform: "translateX(0px) translateY(0px)",
                },
              },
            },
          },
          "&.MuiSwitch-sizeSmall:has(.MuiSwitch-colorDefault)": {
            "& .MuiSwitch-switchBase": {
              padding: "4px",
              borderRadius: "100px",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(:has(.Mui-checked)):not(:has(.Mui-disabled)):has(.Mui-focusVisible)": {
              "& .MuiSwitch-switchBase": {
                transform: "translateX(0px) translateY(0px)",
              },
            },
            "&:not(:has(.Mui-checked)):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible))": {
              width: "40px",
              height: "24px",
              transform: "translateX(0px) translateY(0px)",
              padding: "7px",
              background: "none",
              opacity: "1",
              borderRadius: "0",
              boxShadow: "none",
              "& .MuiSwitch-switchBase": {
                transform: "translateX(0px) translateY(0px)",
                "& .MuiSwitch-thumb": {
                  width: "16px",
                  height: "16px",
                  background: "var(--mui-palette-_components-switch-knobFillEnabled)",
                  boxShadow: "var(--mui-shadows-1)",
                  padding: "0",
                  opacity: "1",
                  borderRadius: "50%",
                },
                "& + .MuiSwitch-track": {
                  width: "26px",
                  height: "10px",
                  borderRadius: "100px",
                  background: "var(--mui-palette-_components-switch-slideFill)",
                  padding: "0",
                  opacity: "0.38",
                  boxShadow: "none",
                  transform: "translateX(0px) translateY(0px)",
                },
              },
            },
            "&:has(.Mui-checked):not(:has(.Mui-disabled)):has(.Mui-focusVisible)": {
              "& .MuiSwitch-switchBase": {
                transform: "translateX(16px) translateY(0px)",
              },
            },
            "&:has(.Mui-checked):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible))": {
              width: "40px",
              height: "24px",
              transform: "translateX(0px) translateY(0px)",
              padding: "7px",
              background: "none",
              opacity: "1",
              borderRadius: "0",
              boxShadow: "none",
              "& .MuiSwitch-switchBase": {
                transform: "translateX(16px) translateY(0px)",
                "& .MuiSwitch-thumb": {
                  width: "16px",
                  height: "16px",
                  background: "var(--mui-palette-common-white_states-main)",
                  boxShadow: "var(--mui-shadows-1)",
                  padding: "0",
                  opacity: "1",
                  borderRadius: "50%",
                },
                "& + .MuiSwitch-track": {
                  width: "26px",
                  height: "10px",
                  borderRadius: "100px",
                  background: "var(--mui-palette-_components-switch-slideFill)",
                  padding: "0",
                  opacity: "0.5",
                  boxShadow: "none",
                  transform: "translateX(0px) translateY(0px)",
                },
              },
            },
          },
          "&.MuiSwitch-sizeSmall:has(.MuiSwitch-colorPrimary)": {
            "& .MuiSwitch-switchBase": {
              padding: "4px",
              borderRadius: "100px",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(:has(.Mui-checked)):not(:has(.Mui-disabled)):has(.Mui-focusVisible)": {
              "& .MuiSwitch-switchBase": {
                transform: "translateX(0px) translateY(0px)",
              },
            },
            "&:not(:has(.Mui-checked)):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible))": {
              width: "40px",
              height: "24px",
              transform: "translateX(0px) translateY(0px)",
              padding: "7px",
              background: "none",
              opacity: "1",
              borderRadius: "0",
              boxShadow: "none",
              "& .MuiSwitch-switchBase": {
                transform: "translateX(0px) translateY(0px)",
                "& .MuiSwitch-thumb": {
                  width: "16px",
                  height: "16px",
                  background: "var(--mui-palette-_components-switch-knobFillEnabled)",
                  boxShadow: "var(--mui-shadows-1)",
                  padding: "0",
                  opacity: "1",
                  borderRadius: "50%",
                },
                "& + .MuiSwitch-track": {
                  width: "26px",
                  height: "10px",
                  borderRadius: "100px",
                  background: "var(--mui-palette-_components-switch-slideFill)",
                  padding: "0",
                  opacity: "0.38",
                  boxShadow: "none",
                  transform: "translateX(0px) translateY(0px)",
                },
              },
            },
            "&:has(.Mui-checked):not(:has(.Mui-disabled)):has(.Mui-focusVisible)": {
              "& .MuiSwitch-switchBase": {
                transform: "translateX(16px) translateY(0px)",
              },
            },
            "&:has(.Mui-checked):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible))": {
              width: "40px",
              height: "24px",
              transform: "translateX(0px) translateY(0px)",
              padding: "7px",
              background: "none",
              opacity: "1",
              borderRadius: "0",
              boxShadow: "none",
              "& .MuiSwitch-switchBase": {
                transform: "translateX(16px) translateY(0px)",
                "& .MuiSwitch-thumb": {
                  width: "16px",
                  height: "16px",
                  background: "var(--mui-palette-primary-main)",
                  boxShadow: "var(--mui-shadows-1)",
                  padding: "0",
                  opacity: "1",
                  borderRadius: "50%",
                },
                "& + .MuiSwitch-track": {
                  width: "26px",
                  height: "10px",
                  borderRadius: "100px",
                  background: "var(--mui-palette-primary-main)",
                  padding: "0",
                  opacity: "0.5",
                  boxShadow: "none",
                  transform: "translateX(0px) translateY(0px)",
                },
              },
            },
          },
          "&.MuiSwitch-sizeSmall:has(.MuiSwitch-colorError)": {
            "& .MuiSwitch-switchBase": {
              padding: "4px",
              borderRadius: "100px",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(:has(.Mui-checked)):not(:has(.Mui-disabled)):has(.Mui-focusVisible)": {
              "& .MuiSwitch-switchBase": {
                transform: "translateX(0px) translateY(0px)",
              },
            },
            "&:not(:has(.Mui-checked)):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible))": {
              width: "40px",
              height: "24px",
              transform: "translateX(0px) translateY(0px)",
              padding: "7px",
              background: "none",
              opacity: "1",
              borderRadius: "0",
              boxShadow: "none",
              "& .MuiSwitch-switchBase": {
                transform: "translateX(0px) translateY(0px)",
                "& .MuiSwitch-thumb": {
                  width: "16px",
                  height: "16px",
                  background: "var(--mui-palette-_components-switch-knobFillEnabled)",
                  boxShadow: "var(--mui-shadows-1)",
                  padding: "0",
                  opacity: "1",
                  borderRadius: "50%",
                },
                "& + .MuiSwitch-track": {
                  width: "26px",
                  height: "10px",
                  borderRadius: "100px",
                  background: "var(--mui-palette-_components-switch-slideFill)",
                  padding: "0",
                  opacity: "0.38",
                  boxShadow: "none",
                  transform: "translateX(0px) translateY(0px)",
                },
              },
            },
            "&:has(.Mui-checked):not(:has(.Mui-disabled)):has(.Mui-focusVisible)": {
              "& .MuiSwitch-switchBase": {
                transform: "translateX(16px) translateY(0px)",
              },
            },
            "&:has(.Mui-checked):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible))": {
              width: "40px",
              height: "24px",
              transform: "translateX(0px) translateY(0px)",
              padding: "7px",
              background: "none",
              opacity: "1",
              borderRadius: "0",
              boxShadow: "none",
              "& .MuiSwitch-switchBase": {
                transform: "translateX(16px) translateY(0px)",
                "& .MuiSwitch-thumb": {
                  width: "16px",
                  height: "16px",
                  background: "var(--mui-palette-error-main)",
                  boxShadow: "var(--mui-shadows-1)",
                  padding: "0",
                  opacity: "1",
                  borderRadius: "50%",
                },
                "& + .MuiSwitch-track": {
                  width: "26px",
                  height: "10px",
                  borderRadius: "100px",
                  background: "var(--mui-palette-error-main)",
                  padding: "0",
                  opacity: "0.5",
                  boxShadow: "none",
                  transform: "translateX(0px) translateY(0px)",
                },
              },
            },
          },
          "&.MuiSwitch-sizeSmall:has(.MuiSwitch-colorWarning)": {
            "& .MuiSwitch-switchBase": {
              padding: "4px",
              borderRadius: "100px",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(:has(.Mui-checked)):not(:has(.Mui-disabled)):has(.Mui-focusVisible)": {
              "& .MuiSwitch-switchBase": {
                transform: "translateX(0px) translateY(0px)",
              },
            },
            "&:not(:has(.Mui-checked)):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible))": {
              width: "40px",
              height: "24px",
              transform: "translateX(0px) translateY(0px)",
              padding: "7px",
              background: "none",
              opacity: "1",
              borderRadius: "0",
              boxShadow: "none",
              "& .MuiSwitch-switchBase": {
                transform: "translateX(0px) translateY(0px)",
                "& .MuiSwitch-thumb": {
                  width: "16px",
                  height: "16px",
                  background: "var(--mui-palette-_components-switch-knobFillEnabled)",
                  boxShadow: "var(--mui-shadows-1)",
                  padding: "0",
                  opacity: "1",
                  borderRadius: "50%",
                },
                "& + .MuiSwitch-track": {
                  width: "26px",
                  height: "10px",
                  borderRadius: "100px",
                  background: "var(--mui-palette-_components-switch-slideFill)",
                  padding: "0",
                  opacity: "0.38",
                  boxShadow: "none",
                  transform: "translateX(0px) translateY(0px)",
                },
              },
            },
            "&:has(.Mui-checked):not(:has(.Mui-disabled)):has(.Mui-focusVisible)": {
              "& .MuiSwitch-switchBase": {
                transform: "translateX(16px) translateY(0px)",
              },
            },
            "&:has(.Mui-checked):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible))": {
              width: "40px",
              height: "24px",
              transform: "translateX(0px) translateY(0px)",
              padding: "7px",
              background: "none",
              opacity: "1",
              borderRadius: "0",
              boxShadow: "none",
              "& .MuiSwitch-switchBase": {
                transform: "translateX(16px) translateY(0px)",
                "& .MuiSwitch-thumb": {
                  width: "16px",
                  height: "16px",
                  background: "var(--mui-palette-warning-main)",
                  boxShadow: "var(--mui-shadows-1)",
                  padding: "0",
                  opacity: "1",
                  borderRadius: "50%",
                },
                "& + .MuiSwitch-track": {
                  width: "26px",
                  height: "10px",
                  borderRadius: "100px",
                  background: "var(--mui-palette-warning-main)",
                  padding: "0",
                  opacity: "0.5",
                  boxShadow: "none",
                  transform: "translateX(0px) translateY(0px)",
                },
              },
            },
          },
          "&.MuiSwitch-sizeSmall:has(.MuiSwitch-colorInfo)": {
            "& .MuiSwitch-switchBase": {
              padding: "4px",
              borderRadius: "100px",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(:has(.Mui-checked)):not(:has(.Mui-disabled)):has(.Mui-focusVisible)": {
              "& .MuiSwitch-switchBase": {
                transform: "translateX(0px) translateY(0px)",
              },
            },
            "&:not(:has(.Mui-checked)):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible))": {
              width: "40px",
              height: "24px",
              transform: "translateX(0px) translateY(0px)",
              padding: "7px",
              background: "none",
              opacity: "1",
              borderRadius: "0",
              boxShadow: "none",
              "& .MuiSwitch-switchBase": {
                transform: "translateX(0px) translateY(0px)",
                "& .MuiSwitch-thumb": {
                  width: "16px",
                  height: "16px",
                  background: "var(--mui-palette-_components-switch-knobFillEnabled)",
                  boxShadow: "var(--mui-shadows-1)",
                  padding: "0",
                  opacity: "1",
                  borderRadius: "50%",
                },
                "& + .MuiSwitch-track": {
                  width: "26px",
                  height: "10px",
                  borderRadius: "100px",
                  background: "var(--mui-palette-_components-switch-slideFill)",
                  padding: "0",
                  opacity: "0.38",
                  boxShadow: "none",
                  transform: "translateX(0px) translateY(0px)",
                },
              },
            },
            "&:has(.Mui-checked):not(:has(.Mui-disabled)):has(.Mui-focusVisible)": {
              "& .MuiSwitch-switchBase": {
                transform: "translateX(16px) translateY(0px)",
              },
            },
            "&:has(.Mui-checked):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible))": {
              width: "40px",
              height: "24px",
              transform: "translateX(0px) translateY(0px)",
              padding: "7px",
              background: "none",
              opacity: "1",
              borderRadius: "0",
              boxShadow: "none",
              "& .MuiSwitch-switchBase": {
                transform: "translateX(16px) translateY(0px)",
                "& .MuiSwitch-thumb": {
                  width: "16px",
                  height: "16px",
                  background: "var(--mui-palette-info-main)",
                  boxShadow: "var(--mui-shadows-1)",
                  padding: "0",
                  opacity: "1",
                  borderRadius: "50%",
                },
                "& + .MuiSwitch-track": {
                  width: "26px",
                  height: "10px",
                  borderRadius: "100px",
                  background: "var(--mui-palette-info-main)",
                  padding: "0",
                  opacity: "0.5",
                  boxShadow: "none",
                  transform: "translateX(0px) translateY(0px)",
                },
              },
            },
          },
          "&.MuiSwitch-sizeSmall:has(.MuiSwitch-colorSuccess)": {
            "& .MuiSwitch-switchBase": {
              padding: "4px",
              borderRadius: "100px",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:not(:has(.Mui-checked)):not(:has(.Mui-disabled)):has(.Mui-focusVisible)": {
              "& .MuiSwitch-switchBase": {
                transform: "translateX(0px) translateY(0px)",
              },
            },
            "&:not(:has(.Mui-checked)):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible))": {
              width: "40px",
              height: "24px",
              transform: "translateX(0px) translateY(0px)",
              padding: "7px",
              background: "none",
              opacity: "1",
              borderRadius: "0",
              boxShadow: "none",
              "& .MuiSwitch-switchBase": {
                transform: "translateX(0px) translateY(0px)",
                "& .MuiSwitch-thumb": {
                  width: "16px",
                  height: "16px",
                  background: "var(--mui-palette-_components-switch-knobFillEnabled)",
                  boxShadow: "var(--mui-shadows-1)",
                  padding: "0",
                  opacity: "1",
                  borderRadius: "50%",
                },
                "& + .MuiSwitch-track": {
                  width: "26px",
                  height: "10px",
                  borderRadius: "100px",
                  background: "var(--mui-palette-_components-switch-slideFill)",
                  padding: "0",
                  opacity: "0.38",
                  boxShadow: "none",
                  transform: "translateX(0px) translateY(0px)",
                },
              },
            },
            "&:has(.Mui-checked):not(:has(.Mui-disabled)):has(.Mui-focusVisible)": {
              "& .MuiSwitch-switchBase": {
                transform: "translateX(16px) translateY(0px)",
              },
            },
            "&:has(.Mui-checked):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible))": {
              width: "40px",
              height: "24px",
              transform: "translateX(0px) translateY(0px)",
              padding: "7px",
              background: "none",
              opacity: "1",
              borderRadius: "0",
              boxShadow: "none",
              "& .MuiSwitch-switchBase": {
                transform: "translateX(16px) translateY(0px)",
                "& .MuiSwitch-thumb": {
                  width: "16px",
                  height: "16px",
                  background: "var(--mui-palette-success-main)",
                  boxShadow: "var(--mui-shadows-1)",
                  padding: "0",
                  opacity: "1",
                  borderRadius: "50%",
                },
                "& + .MuiSwitch-track": {
                  width: "26px",
                  height: "10px",
                  borderRadius: "100px",
                  background: "var(--mui-palette-success-main)",
                  padding: "0",
                  opacity: "0.5",
                  boxShadow: "none",
                  transform: "translateX(0px) translateY(0px)",
                },
              },
            },
          },
          "&.MuiSwitch-sizeSmall:has(.MuiSwitch-colorSecondary)": {
            "& .MuiSwitch-switchBase": {
              padding: "4px",
              borderRadius: "100px",
              background: "none",
              opacity: "1",
              boxShadow: "none",
            },
            "&:has(.Mui-checked):not(:has(.Mui-disabled)):has(.Mui-focusVisible)": {
              "& .MuiSwitch-switchBase": {
                transform: "translateX(16px) translateY(0px)",
              },
            },
            "&:has(.Mui-checked):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible))": {
              width: "40px",
              height: "24px",
              transform: "translateX(0px) translateY(0px)",
              padding: "7px",
              background: "none",
              opacity: "1",
              borderRadius: "0",
              boxShadow: "none",
              "& .MuiSwitch-switchBase": {
                transform: "translateX(16px) translateY(0px)",
                "& .MuiSwitch-thumb": {
                  width: "16px",
                  height: "16px",
                  background: "var(--mui-palette-secondary-main)",
                  boxShadow: "var(--mui-shadows-1)",
                  padding: "0",
                  opacity: "1",
                  borderRadius: "50%",
                },
                "& + .MuiSwitch-track": {
                  width: "26px",
                  height: "10px",
                  borderRadius: "100px",
                  background: "var(--mui-palette-secondary-main)",
                  padding: "0",
                  opacity: "0.5",
                  boxShadow: "none",
                  transform: "translateX(0px) translateY(0px)",
                },
              },
            },
            "&:not(:has(.Mui-checked)):not(:has(.Mui-disabled)):has(.Mui-focusVisible)": {
              "& .MuiSwitch-switchBase": {
                transform: "translateX(0px) translateY(0px)",
              },
            },
            "&:not(:has(.Mui-checked)):not(:has(.Mui-disabled)):not(:has(.Mui-focusVisible))": {
              width: "40px",
              height: "24px",
              transform: "translateX(0px) translateY(0px)",
              padding: "7px",
              background: "none",
              opacity: "1",
              borderRadius: "0",
              boxShadow: "none",
              "& .MuiSwitch-switchBase": {
                transform: "translateX(0px) translateY(0px)",
                "& .MuiSwitch-thumb": {
                  width: "16px",
                  height: "16px",
                  background: "var(--mui-palette-_components-switch-knobFillEnabled)",
                  boxShadow: "var(--mui-shadows-1)",
                  padding: "0",
                  opacity: "1",
                  borderRadius: "50%",
                },
                "& + .MuiSwitch-track": {
                  width: "26px",
                  height: "10px",
                  borderRadius: "100px",
                  background: "var(--mui-palette-_components-switch-slideFill)",
                  padding: "0",
                  opacity: "0.38",
                  boxShadow: "none",
                  transform: "translateX(0px) translateY(0px)",
                },
              },
            },
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          "&:hover": {
            borderColor: "#9C27B080",
          },
        },
      },
    },
    /*
    do we need styles for hovering on inputs?
    MuiInputBase: {
      styleOverrides: {
        root: {
          "&:hover": {
            border: "1px solid var(--mui-palette-primary-light)",
          }
        },
      },
    } */
  },
};
export default figmaTheme;
